import { template as template_a36aeb1c8e7e404db01670539c4aefbc } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import { filterByIds } from 'eflex/helpers';
import { t } from 'ember-intl';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
export default class BiPanelProcessData extends Component {
    @service
    variableDefRepo;
    @tracked
    isDisplayed = false;
    constructor(){
        super(...arguments);
        this.isDisplayed = this.args.variableDefIds?.length > 0;
        this.args.initParam('variableDefIds', this.args.variableDefIds);
    }
    @action
    onChange(variableDefs) {
        let variableDefIds;
        if (Array.isArray(variableDefs)) {
            variableDefIds = variableDefs.map(({ id })=>id);
        } else {
            variableDefIds = [
                variableDefs.id
            ];
        }
        this.args.updateParam('variableDefIds', variableDefIds);
    }
    get controlType() {
        return this.args.controlType || 'power-select-multiple';
    }
    get filteredVariableDefs() {
        let variableDefs = this.variableDefRepo.variableDefs.filter((item)=>item.type === 'number' || item.isFromDevice);
        if (isPresent(this.args.stationIds)) {
            variableDefs = variableDefs.filter((variableDef)=>this.args.stationIds.includes(variableDef.task?.station?.id));
        }
        return variableDefs;
    }
    get selectedVariableDefs() {
        if (this.controlType === 'power-select-multiple') {
            return filterByIds(this.filteredVariableDefs, this.args.getParam('variableDefIds'));
        }
        const selectedId = this.args.getParam('variableDefIds')?.[0];
        if (!selectedId) {
            return null;
        }
        return this.filteredVariableDefs.find((dataDef)=>dataDef.id === selectedId);
    }
    get selectedVariablesBadgeText() {
        return this.args.createSearchBadgeText('variableDefIds', 'bi.biPanel.process-data', 'criteria.selectedProcessData', 'name', 'variable-def');
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    static{
        template_a36aeb1c8e7e404db01670539c4aefbc(`
      <Portal @target="filter-fields">
        <FilterWrapper
          class="eflex-process-data-criteria"
          @class="align-items-end"
          @form={{@form}}
          @label="processData"
          @isDisplayed={{this.isDisplayed}}
          @onChecked={{this.onDisplayedChanged}}
          @hasValue={{isPresent this.selectedVariableDefs}}
          ...attributes
        >
          <div class="input-group">
            <div class="col">
              <div class="row">
                <div class="col">
                  <@form.element
                    class="process-data-select"
                    @controlType={{this.controlType}}
                    @value={{this.selectedVariableDefs}}
                    @options={{this.filteredVariableDefs}}
                    @optionLabelPath="name"
                    @onChange={{this.onChange}}
                  as |el|>
                    <el.control
                      class="sm"
                      @searchEnabled={{true}}
                      @searchField="name"
                      @placeholder={{t "allProcessData"}}
                    />
                  </@form.element>
                </div>
              </div>
            </div>
          </div>
        </FilterWrapper>
      </Portal>

      <Portal @target="search-badge-tags">
        <SearchTag
          @isDisplayed={{@variableDefIds}}
          @text={{this.selectedVariablesBadgeText}}
        />
      </Portal>
    `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
